import React from 'react';
import Institutional from './Institutional';
import { Route } from 'react-router-dom';

const PageInstitutional = ({ match, routes }) => (
  <div>
    {routes.map(bloc => {
      return bloc.links.map(page => {
        return (
          <Route
            exact
            key={page.text}
            path={`${match.path}${page.to}`}
            render={props => (
              <Institutional {...props} title={bloc.title} page={page} />
            )}
          />
        );
      });
    })}
  </div>
);

export default PageInstitutional;
